<template>
  <div v-if="showModal" class="consent-modal-overlay">
    <div class="consent-modal">
      <h2>{{ $t('consent.title') }}</h2>
      <p>{{ $t('consent.description') }}</p>
      <div class="consent-options">
        <div class="consent-option">
          <input 
            type="checkbox" 
            id="necessary" 
            v-model="consents.necessary" 
            disabled 
            checked
          />
          <label for="necessary">
            <strong>{{ $t('consent.necessary_title') }}</strong>
            <p>{{ $t('consent.necessary_description') }}</p>
          </label>
        </div>
        <div class="consent-option">
          <input 
            type="checkbox" 
            id="analytics" 
            v-model="consents.analytics"
          />
          <label for="analytics">
            <strong>{{ $t('consent.analytics_title') }}</strong>
            <p>{{ $t('consent.analytics_description') }}</p>
          </label>
        </div>
        <div class="consent-option">
          <input 
            type="checkbox" 
            id="marketing" 
            v-model="consents.marketing"
          />
          <label for="marketing">
            <strong>{{ $t('consent.marketing_title') }}</strong>
            <p>{{ $t('consent.marketing_description') }}</p>
          </label>
        </div>
      </div>
      <div class="consent-buttons">
        <button @click="acceptAll" class="accept-all-btn">
          {{ $t('consent.accept_all') }}
        </button>
        <button @click="savePreferences" class="save-preferences-btn">
          {{ $t('consent.save_preferences') }}
        </button>
      </div>
      <div class="privacy-link">
        <router-link to="/privacy-policy">{{ $t('consent.privacy_policy_link') }}</router-link>
      </div>
    </div>
  </div>
</template>

<script setup>
import { ref, onMounted } from 'vue'

const emit = defineEmits(['consentSaved'])
const showModal = ref(false)
const consents = ref({
  necessary: true,
  analytics: false,
  marketing: false
})

onMounted(() => {
  // Check if consent was already given
  const savedConsent = localStorage.getItem('gdprConsent')
  if (!savedConsent) {
    showModal.value = true
  } else {
    try {
      consents.value = JSON.parse(savedConsent)
    } catch (e) {
      // If parsing fails, show the modal again
      showModal.value = true
    }
  }
})

const acceptAll = () => {
  consents.value = {
    necessary: true,
    analytics: true,
    marketing: true
  }
  savePreferences()
}

const savePreferences = () => {
  localStorage.setItem('gdprConsent', JSON.stringify(consents.value))
  showModal.value = false
  emit('consentSaved', consents.value)
}
</script>

<style scoped>
.consent-modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(0, 0, 0, 0.5);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1000;
}

.consent-modal {
  background-color: white;
  border-radius: 8px;
  padding: 24px;
  max-width: 600px;
  width: 90%;
  max-height: 90vh;
  overflow-y: auto;
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
}

.consent-options {
  margin: 20px 0;
}

.consent-option {
  display: flex;
  align-items: flex-start;
  margin-bottom: 16px;
}

.consent-option input {
  margin-top: 4px;
  margin-right: 10px;
}

.consent-option label {
  flex: 1;
}

.consent-option p {
  margin: 5px 0 0;
  font-size: 0.9em;
  color: #666;
}

.consent-buttons {
  display: flex;
  justify-content: space-between;
  margin-top: 20px;
}

.accept-all-btn, .save-preferences-btn {
  padding: 10px 20px;
  border-radius: 4px;
  cursor: pointer;
  border: none;
  font-weight: bold;
}

.accept-all-btn {
  background-color: #4CAF50;
  color: white;
}

.save-preferences-btn {
  background-color: #f5f5f5;
  color: #333;
  border: 1px solid #ddd;
}

.privacy-link {
  margin-top: 16px;
  text-align: center;
  font-size: 0.9em;
}

@media (max-width: 768px) {
  .consent-buttons {
    flex-direction: column;
    gap: 10px;
  }
  
  .accept-all-btn, .save-preferences-btn {
    width: 100%;
  }
}
</style> 